import { Radio } from 'antd';
import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import PaymentTypeReceiverNoCOD from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeReceiverNoCOD';
import PaymentTypeReceiverWithCOD from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeReceiverWithCOD';
// import PaymentTypeSenderAndReceiver from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeSenderAndReceiver';
// import PaymentTypeSenderNoCODCredit from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeSenderNoCODCredit';
// import PaymentTypeSenderNoCODWallet from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeSenderNoCODWallet';
// import PaymentTypeSenderWithCODCredit from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeSenderWithCODCredit';
// import PaymentTypeSenderWithCODWallet from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeSenderWithCODWallet';
//import { orderCost } from 'global/Models/omOrderModel';
import { FC, ReactNode, useEffect, useState } from 'react';
import { priceTypeBranch } from '../../BranchOrder/BranchParcelOrderPrice';
import PaymentTypeSenderNoCOD from '../../orderMethods/components/PaymentTypeSenderNoCOD';

interface IOrderSummeryPayment {
  orderMethods: orderMethodsState;
  priceList?: priceTypeBranch[];
}

const _banks: { src: string; name: string }[] = [
  { name: 'mellat', src: '/logo_mellat_bank.svg' },
  { name: 'persian', src: '/logo_parsian_bank.svg' },
  { name: 'saman', src: '/logo_saman_bank.png' },
];

type paymentMethod = 'internet' | 'wallet' | 'credit';

const _MethodItem = ({
  setPaymentMethod,
  name,
  paymentMethod,
  children,
  title,
  disabled,
}: {
  children: ReactNode;
  name: paymentMethod;
  setPaymentMethod: (_method: paymentMethod) => void;
  paymentMethod: paymentMethod;
  title: string;
  disabled?: boolean;
}) => {
  const isSelected = paymentMethod === name;
  return (
    <div
      className={`flex flex-col justify-between w-full gap-4 px-6 py-4 border sm:flex-row sm:items-center border-t-border-color-base rounded-xl ${
        isSelected && 'border-t-primary-color'
      } ${disabled ? 'color-inherit text-t-secondary-text-color' : ''}`}>
      <div className='flex gap-4 cursor-pointer w-fit group' onClick={() => !disabled && setPaymentMethod(name)}>
        <Radio checked={isSelected} disabled={disabled} />
        <div>
          <label
            className={`text-base font-medium   ${isSelected ? 'text-t-primary-color' : ''} ${
              disabled ? 'color-inherit text-t-secondary-text-color' : 'group-hover:text-t-primary-color cursor-pointer'
            }`}>
            {title}
          </label>
          {disabled && <span className='block text-xs'>موجودی ناکافی</span>}
        </div>
      </div>
      {children}
    </div>
  );
};

const OrderSummeryPayment: FC<IOrderSummeryPayment> = ({ orderMethods }) => {
  //state
  const [paymentMethod, setPaymentMethod] = useState<paymentMethod>('internet');
  const [_selectedBank, setSelectedBank] = useState<string>('saman');

  //effect
  useEffect(() => {
    if (paymentMethod !== 'internet') setSelectedBank('');
  }, [paymentMethod]);

  //functions
  const _handleBankChange = (bank: string) => {
    setSelectedBank(bank);
    setPaymentMethod('internet');
  };

  return (
    <div className=''>
      {/* <PaymentTypeSenderNoCODCredit
        invalid={orderMethods.paymentTypeId !== 10}
        isSelected={orderMethods.paymentTypeId == 10}
        onChange={() => {}}
        priceList={priceList}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      /> */}
      <PaymentTypeReceiverNoCOD
        invalid={orderMethods.paymentTypeId !== 20}
        isSelected={orderMethods.paymentTypeId == 20}
        onChange={() => {}}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      />
      <PaymentTypeReceiverWithCOD
        invalid={orderMethods.paymentTypeId !== 30}
        isSelected={orderMethods.paymentTypeId == 30}
        onChange={() => {}}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      />
      {/* <PaymentTypeSenderWithCODCredit
        invalid={orderMethods.paymentTypeId !== 40}
        isSelected={orderMethods.paymentTypeId == 40}
        onChange={() => {}}
        priceList={priceList}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      /> */}
      {/* <PaymentTypeSenderNoCODWallet
        invalid={orderMethods.paymentTypeId !== 50}
        isSelected={orderMethods.paymentTypeId == 50}
        onChange={() => {}}
        priceList={priceList}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      />
      <PaymentTypeSenderWithCODWallet
        invalid={orderMethods.paymentTypeId !== 60}
        isSelected={orderMethods.paymentTypeId == 60}
        onChange={() => {}}
        priceList={priceList}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      /> */}
      {/* <PaymentTypeSenderAndReceiver
        invalid={orderMethods.paymentTypeId !== 70}
        isSelected={orderMethods.paymentTypeId == 70}
        onChange={() => {}}
        priceList={priceList}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
        cashAmount={orderMethods.cashAmount}
        setCashAmount={(_value: string | number) => {}}
        viewOnly
      /> */}
      <PaymentTypeSenderNoCOD
        invalid={orderMethods.paymentTypeId !== 80}
        isSelected={orderMethods.paymentTypeId == 80}
        onChange={() => {}}
        setError={(_value: string) => {}}
        error={orderMethods.paymentTypeError || ''}
      />
    </div>
  );
};

export default OrderSummeryPayment;
